import { z } from 'zod';
export const baseActionsTaken = z.object({
    actionsTakenA: z.string().optional(),
    actionsTakenB: z.string().optional(),
    actionsTakenC: z.string().optional(),
});
export const baseAbilityAssessment = z.object({
    injectionsConfirmed: z.string().optional(),
    injectionAssistance: z.string().optional(),
    abilityAssessment: z.array(z.string()),
});
export const baseN0415 = z.object({
    n0415a1: z.boolean().optional(),
    n0415a2: z.boolean().optional(),
    n0415e1: z.boolean().optional(),
    n0415e2: z.boolean().optional(),
    n0415f1: z.boolean().optional(),
    n0415f2: z.boolean().optional(),
    n0415h1: z.boolean().optional(),
    n0415h2: z.boolean().optional(),
    n0415i1: z.boolean().optional(),
    n0415i2: z.boolean().optional(),
    n0415j1: z.boolean().optional(),
    n0415j2: z.boolean().optional(),
    n0415z1: z.boolean().optional(),
    n0415z2: z.boolean().optional(),
});
export const SectionN = {
    n0415: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
        fields: {
            a1: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            a2: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            e1: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            e2: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            f1: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            f2: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            h1: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            h2: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            i1: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            i2: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            j1: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            j2: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
            z1: { version: ['e1'], timepoint: ['soc', 'roc', 'dsch'] },
        },
    },
    m2001: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    actionsTaken: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    m2003: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    m2005: {
        version: ['e1'],
        timepoint: ['tr', 'trd', 'dth', 'dsch'],
    },
    m2010: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    m2020: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
    },
    m2030: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
    abilityAssessment: {
        version: ['e1'],
        timepoint: ['soc', 'roc'],
    },
};
// N-M2001_DRUG_RGMN_RVW-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"No - no issues found during review"},{"value":"1","label":"Yes - issues found during review"},{"value":"9","label":"NA - patient is not taking any medications"},{"value":"-","label":"Not assessed/no information"}]
// N-M2003_MDCTN_FLWP-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"No"},{"value":"1","label":"Yes"},{"value":"-","label":"Not assessed/no information"},{"value":"^","label":"Blank (skip pattern)"}]
// N-M2005_MDCTN_INTRVTN-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"No"},{"value":"1","label":"Yes"},{"value":"9","label":"NA - There were no potential clinically significant medication issues identified since SOC/ROC or patient is not taking any medications"},{"value":"-","label":"Not assessed/no information"}]
// N-M2010_HIGH_RISK_DRUG_EDCTN-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"No"},{"value":"01","label":"Yes"},{"value":"NA","label":"Not Applicable"},{"value":"^","label":"Blank (skip pattern)"}]
// N-M2020_CRNT_MGMT_ORAL_MDCTN-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"Able to independently take the correct oral medication(s) and proper dosage(s) at the correct times."},{"value":"01","label":"Able to take medication(s) at the correct times if:  (a) individual dosages are prepared in advance by another person; OR (b) another person develops a drug diary or chart."},{"value":"02","label":"Able to take medication(s) at the correct times if given reminders by another person at the appropriate times."},{"value":"03","label":"Unable to take medication unless administered by another person."},{"value":"NA","label":"No oral medications prescribed."},{"value":"^","label":"Blank (skip pattern)"}]
// N-M2030_CRNT_MGMT_INJCTN_MDCTN-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"Able to independently take the correct medication(s) and proper syringe(s) at the correct times."},{"value":"01","label":"Able to take injectable medication(s) at the correct times if:  (a) individual dosages are prepared in advance by another person; OR (b) another person develops a drug diary or chart."},{"value":"02","label":"Able to take medication(s) at the correct times if given reminders by another person based on the frequency of the injection."},{"value":"03","label":"Unable to take injectable medication unless administered by another person."},{"value":"NA","label":"No injectable medications prescribed."},{"value":"^","label":"Blank (skip pattern)"}]
// N-N0415A1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415A2-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"^","label":"Blank (skip pattern)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415E1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415E2-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"^","label":"Blank (skip pattern)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415F1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415F2-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"^","label":"Blank (skip pattern)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415H1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415H2-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"^","label":"Blank (skip pattern)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415I1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415I2-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"^","label":"Blank (skip pattern)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415J1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415J2-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"^","label":"Blank (skip pattern)"},{"value":"-","label":"Not assessed/no information"}]
// N-N0415Z1-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"},{"value":"-","label":"Not assessed/no information"}]
